export default __webpack_public_path__ + "static/media/news34.f4e82e80.jpg";